/**
 *    DCC sticky locations
 */

(function ($) {
  Drupal.behaviors.dccStickyLocations = {
    attach(context, settings) {
      const self = this;

      let markupInner = '';
      const $snippetItems = $('.vb-dcc-detail-snippet__item');
      const $stickyLocations = $('.vb-dcc-sticky-locations');
      const $stickyLocationsItems = $stickyLocations.find('.vb-dcc-sticky-locations__items');

      $snippetItems.each((index, element) => {
        const $item = $(element);
        const $image = $item.find('.vb-media-gallery__link').first().find('picture').html();
        const json = $item.data('json');
        const { title } = json.properties.location;
        const { type } = json.properties.location;
        const { id } = json.properties.location;
        const { url } = json.properties.location;
        let activeItemClass = '';

        if (index === 0) {
          activeItemClass = 'vb-active';
        } else {
          setTimeout(() => {
            $item.addClass('vb-hidden');
          }, 100);
        }

        markupInner
          += '<li class="vb-dcc-sticky-locations__item">'
            + '<span class="vb-dcc-sticky-locations__entry">'
              + `<a href="#" class="vb-dcc-sticky-locations__link ${activeItemClass}" id="${id}">`
                + '<figure class="vb-dcc-sticky-locations__figure">'
                  + `<picture>${$image}</picture>`
                + '</figure>'
                + `<span class="vb-dcc-sticky-locations__sub">${type}</span>`
                + `<span class="vb-dcc-sticky-locations__title">${self.dccTextTruncate(title, 25)}</span>`
              + '</a>'
              + `<a class="vb-dcc-sticky-locations__external" href="${url}" target="_blank">`
                + '<span class="icon-external-link"></span>'
              + '</a>'
            + '</span>'
          + '</li>';
      });

      // append sticky locations
      $stickyLocationsItems.append(markupInner);

      const $dccDetailPage = $('.vb-dcc-detail-page');
      const $stickyLocationsButtonPrev = $stickyLocations.find('.vb-dcc-sticky-locations__button.vb-prev');
      const $stickyLocationsButtonNext = $stickyLocations.find('.vb-dcc-sticky-locations__button.vb-next');
      const $stickyLocationsItemFirstChild = $stickyLocations.find('.vb-dcc-sticky-locations__item:first-child');
      const $stickyLocationsItemLastChild = $stickyLocations.find('.vb-dcc-sticky-locations__item:last-child');

      // fade in dcc content
      setTimeout(() => {
        $dccDetailPage.removeClass('vb-loading');
      }, 1200);

      // show or hide filter scrolling indicator buttons
      self.dccStickyScrollIndicator($stickyLocationsItemFirstChild[0], 'first-child', $stickyLocationsButtonPrev, $stickyLocationsButtonNext);
      self.dccStickyScrollIndicator($stickyLocationsItemLastChild[0], 'last-child', $stickyLocationsButtonPrev, $stickyLocationsButtonNext);

      // click filter scrolling indicator buttons
      $stickyLocationsButtonPrev[0].addEventListener('click', () => { self.dccStickyScrollFilter($stickyLocationsButtonPrev[0], 'prev', $stickyLocationsItems[0]); });
      $stickyLocationsButtonNext[0].addEventListener('click', () => { self.dccStickyScrollFilter($stickyLocationsButtonNext[0], 'next', $stickyLocationsItems[0]); });

      // is sticky top?
      self.dccStickyIsSticky($dccDetailPage.find('.vb-grid--detail-page')[0], $stickyLocations, 'top');

      // is sticky bottom?
      self.dccStickyIsSticky($('.vb-map-detail-cluster__sticky-indicator')[0], $stickyLocations, 'bottom');

      // click an item
      const $stickyLocationsItemButton = $('.vb-dcc-sticky-locations__link');
      $stickyLocationsItemButton.on('click scrollItemIntoView', (event) => {
        self.dccStickyScrollItem(event.currentTarget, $stickyLocationsItems[0]);
      });

      $stickyLocationsItemButton.on('click', function (event) {
        event.preventDefault();
        const $button = $(this);
        const targetId = $button.attr('id');
        const $target = $(`.vb-dcc-detail-snippet__item[data-snippet-id="${targetId}"]`);

        // activate card
        $button
          .addClass('vb-active')
          .parent()
          .parent()
          .siblings()
          .find('.vb-active')
          .removeClass('vb-active');

        // show snippet content
        $target
          .removeClass('vb-hidden')
          .siblings()
          .addClass('vb-hidden');

        window.scroll({
          top: $('.vb-map-detail-cluster').offset().top - 200, // 200 = offset
          behavior: 'smooth',
        });
      });

      // append request button
      self.appendRequestButtonToContactBox();
    },

    /**
     * Append the request button to the contact box
     */
    appendRequestButtonToContactBox() {
      const $button = $('.vb-dcc-sticky-locations__button.vb-submit');
      const buttonHref = $button.attr('href');
      const buttonText = $button.find('.vb-dcc-sticky-locations__text').text();

      // create and append button
      $('.vb-grid--dcc .vb-card__content').append(`<a class="vb-button vb-button--secondary vb-button--dcc-request" href="${buttonHref}">${buttonText}</div>`);
    },

    /**
     * Truncate title
     * @param text string
     * @param cut number
     */
    dccTextTruncate(text, cut) {
      if (text.length > cut) {
        return `${text.substring(0, cut)}…`;
      }

      return text;
    },

    /**
     * Header is sticky?
     * @param item DOM element
     */
    dccStickyIsSticky(item, $stickyLocations, state) {
      // observe
      new IntersectionObserver(((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (state === 'top') {
              $stickyLocations.removeClass('vb-sticky--top');
            } else {
              $stickyLocations.removeClass('vb-sticky--bottom');
            }
          } else if (state === 'top') {
            $stickyLocations.addClass('vb-sticky--top');
          } else {
            $stickyLocations.addClass('vb-sticky--bottom');
          }
        });
      }), {
        // root: document.body,
        rootMargin: '0px 0px 0px 0px',
        threshold: 0,
      }).observe(item);
    },

    /**
     * Show or hide up and down buttons
     * @param item DOM element
     * @param type string {first-child}
     */
    dccStickyScrollIndicator(item, type, $stickyLocationsButtonPrev, $stickyLocationsButtonNext) {
      // observe
      new IntersectionObserver(((entries, observer) => {
        entries.forEach((entry) => {
          if (type === 'first-child') {
            if (entry.isIntersecting) {
              $stickyLocationsButtonPrev.attr('disabled', 'disabled');
            } else {
              $stickyLocationsButtonPrev.removeAttr('disabled');
            }
          } else if (entry.isIntersecting) {
            $stickyLocationsButtonNext.attr('disabled', 'disabled');
          } else {
            $stickyLocationsButtonNext.removeAttr('disabled');
          }
        });
      }), {
        // root: document.body,
        rootMargin: '0px 0px 0px 0px',
        threshold: 1,
      }).observe(item);
    },

    /**
     * Scroll up or down
     * @param button DOM element
     * @param type string {up, down}
     */
    dccStickyScrollFilter(button, type, stickyLocationsItems) {
      const offsetWidth = stickyLocationsItems.offsetWidth / 2 >= 200 ? stickyLocationsItems.offsetWidth / 2 : 200;
      const currentScrollPosition = stickyLocationsItems.scrollLeft;
      const direction = type === 'prev' ? currentScrollPosition - offsetWidth : currentScrollPosition + offsetWidth;

      stickyLocationsItems.scrollTo({
        left: direction,
        behavior: 'smooth',
      });
    },

    /**
     * Click a item
     * @param button DOM element
     * @param stickyLocationsItems DOM element
     */
    dccStickyScrollItem(button, stickyLocationsItems) {
      if (stickyLocationsItems.scrollLeft + 60 > button.parentElement.offsetLeft) {
        stickyLocationsItems.scrollTo({
          left: stickyLocationsItems.scrollLeft - 60 - (stickyLocationsItems.scrollLeft - button.parentElement.offsetLeft),
          behavior: 'smooth',
        });
      } else if (button.offsetWidth + button.parentElement.offsetLeft - stickyLocationsItems.scrollLeft > stickyLocationsItems.offsetWidth) {
        const scrollGap = button.offsetWidth + button.parentElement.offsetLeft - stickyLocationsItems.scrollLeft - stickyLocationsItems.offsetWidth;
        stickyLocationsItems.scrollTo({
          left: stickyLocationsItems.scrollLeft + scrollGap + 60,
          behavior: 'smooth',
        });
      }
    },
  };
}(jQuery));

// end of dcc-sticky-locations.js
